import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
// import logo from './logo.svg';
import './App.css';
// import Ladder from './components/ladder'
import TeamSubmission from './components/teamSubmission';
import DraftLinks from './components/draftLinks';

class App extends Component {
  constructor(props){
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Router>
        <div className="App">
          <header className="App-header">
            {/* <img src={logo} className="App-logo" alt="logo" /> */}
            <h1 className="App-title">Doctor Douglas Howser Premiership Cup</h1>
          </header>
          <Switch>
            <Route path="/Home/DraftLinks">
              <DraftLinks />
            </Route>
            <Route path="/">
              <TeamSubmission season="{this.state.season}" />
            </Route>
          </Switch>
        </div>
      </Router>
    );
  }
}

export default App;
